import React, { useEffect, useState } from "react";
import api, { API_BASE } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";

function Card({ title, value, color = "#5BC5F2", icon }) {
  return (
    <div className="card-hsg p-5">
      <div className="flex items-center justify-between">
        <div className="text-xs uppercase tracking-widest text-neutral-500">{title}</div>
        {icon && <span className="text-2xl">{icon}</span>}
      </div>
      <div className="text-3xl font-black mt-2" style={{ color }}>{value ?? "—"}</div>
    </div>
  );
}

export default function AdminDashboard() {
  const { admin } = useAuth();
  const [stats, setStats] = useState({ programme: null, ateliers: null, restauration: null, tickets: null });
  const [apiStatus, setApiStatus] = useState("");
  const [rootResp, setRootResp] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = async () => {
    setLoading(true);
    try {
      const [r, p, a, res, tk] = await Promise.all([
        api.get("/"),
        api.get("/programme").catch(() => ({ data: [] })),
        api.get("/ateliers").catch(() => ({ data: [] })),
        api.get("/restauration").catch(() => ({ data: [] })),
        api.get("/tickets/types").catch(() => ({ data: [] })),
      ]);
      setRootResp(r.data);
      setApiStatus("ok");
      setStats({ programme: p.data.length, ateliers: a.data.length, restauration: res.data.length, tickets: tk.data.length });
    } catch (e) { setApiStatus("error"); }
    finally { setLoading(false); }
  };
  useEffect(() => { refresh(); }, []);

  return (
    <div className="p-4 md:p-8 max-w-6xl">
      <h1 className="text-4xl font-black" style={{ color: "#FEC900" }}>Bienvenue, {admin?.name}</h1>
      <p className="text-neutral-400 mt-2">Console d'administration du festival</p>

      <button onClick={refresh} className="mt-4 px-5 py-2 rounded-lg bg-neutral-800 hover:bg-neutral-700 text-sm font-semibold" data-testid="dashboard-refresh">
        {loading ? "…" : "Actualiser"}
      </button>

      <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        <div className="card-hsg p-5">
          <div className="text-xs uppercase tracking-widest text-neutral-500">API</div>
          <div className="mt-2">
            <span className={`chip ${apiStatus === "ok" ? "" : ""}`} style={{ background: apiStatus === "ok" ? "#A1C86122" : "#E72E4A22", color: apiStatus === "ok" ? "#A1C861" : "#E72E4A", border: `1px solid ${apiStatus === "ok" ? "#A1C861" : "#E72E4A"}55` }}>
              {apiStatus === "ok" ? "EN LIGNE" : "HORS LIGNE"}
            </span>
          </div>
        </div>
        <Card title="Programme" value={stats.programme} icon="🎪" color="#F5ACB4" />
        <Card title="Ateliers" value={stats.ateliers} icon="🎨" color="#A1C861" />
        <Card title="Restauration" value={stats.restauration} icon="🍔" color="#FEC900" />
        <Card title="Types de pass" value={stats.tickets} icon="🎟️" color="#8389C3" />
      </div>

      <div className="card-hsg p-5 mt-4">
        <div className="text-xs uppercase tracking-widest text-neutral-500 mb-2">Réponse API racine</div>
        <pre className="text-xs text-neutral-300 bg-neutral-900 p-3 rounded-lg overflow-x-auto">{rootResp ? JSON.stringify(rootResp, null, 2) : "—"}</pre>
      </div>

      <div className="card-hsg p-5 mt-4">
        <div className="text-xs uppercase tracking-widest text-neutral-500 mb-2">Configuration technique</div>
        <div className="text-sm text-neutral-300 space-y-1">
          <div>Backend URL : <span className="font-mono text-neutral-100">{API_BASE}</span></div>
          <div>Session admin : <span className="font-mono text-neutral-100">{admin?.isSuperAdmin ? "Admin" : (admin?.allowedAteliers?.length ? `${admin.allowedAteliers.length} ateliers` : "Restreint")}</span></div>
        </div>
      </div>
    </div>
  );
}
